export default {
    setShowRightSideBarTrue(state) {
        state.showRightSideBar = true;
    },
    setShowRightSideBarFalse(state) {
        state.showRightSideBar = false;
    },
}